<template>
  <section class="text-black terms">
    <div v-if="isLoading">{{ content.TERMS_SECTION_CONTENT.LOADING_TEXT }}</div>
    <div v-else-if="error">{{ content.TERMS_SECTION_CONTENT.ERROR_TEXT }}</div>
    <div v-else-if="contents && contents.length > 0">
      <div v-for="(item, index) in contents" :key="index">
        <h1 id="modalTitle" class="text-h2 text-center font-bold my-4">
          {{ content.TERMS_SECTION_CONTENT.TITLES[index] }}
        </h1>
        <section v-for="(content, idx) in item" :key="idx" v-html="content.content1">
        </section>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useTermsAndConditions } from '@/composables/useDotCMSContent';
// import * as content from '@/constants/content';
import { useConfigStore } from '@/stores/modules/configStore';

const content = useConfigStore().affiliateConfig.contents;

const { data: contents, isLoading, error } = useTermsAndConditions();
</script>

<style lang="scss">
.terms ol {
  margin-left: 1.5rem;
  list-style-type: decimal;
}
.terms ul {
  margin-left: 1.5rem;
  list-style-type: disc;
  background-color: transparent;
}
.terms ul li, .terms ol li {
  padding-left: .5rem;
  padding-bottom: .5rem;
}
.terms ul ::marker, ol ::marker {
  color: #6905F2;
}
</style>